<template>
  <div id="app">
    <router-view />

    <!-- 全局 Footer -->
    <div class="app-footer">
      {{$t('footer.footer')}}
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
#app {
  min-height: 100vh;
  position: relative;
}

/* 全局 Footer */
.app-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;

  height: 22px;
  line-height: 22px;

  background: #DCE1E6;
  border-top: 1px solid #cbd7ef;

  font-size: 11px;
  color: #000000;

  text-align: right;
  padding: 0 10px;
  box-sizing: border-box;

  z-index: 999;
}
</style>
